<script lang="ts" setup>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const initAni = () => {
  const gTimeLine = gsap.timeline()
  gTimeLine
    .fromTo(
      '.section2__box:nth-child(1) .section2__titleBox',
      {
        opacity: 0
      },
      {
        opacity: 1,
        scrollTrigger: {
          trigger: '.section2__box:nth-child(1)',
          start: 'top',
          end: 'bottom',
          scrub: true,
          pin: true
        }
      }
    )
    .fromTo(
      '.section2__box:nth-child(2) .section2__titleBox',
      {
        opacity: 0
      },
      {
        opacity: 1,
        scrollTrigger: {
          trigger: '.section2__box:nth-child(2)',
          start: 'top',
          end: 'bottom',
          scrub: true,
          pin: true
        }
      }
    )
}

onMounted(() => {
  useImagesLoaded('.section2__box img').then(initAni)
})
</script>

<template>
  <section class="section2">
    <div class="section2__box">
      <figure class="section2__pic">
        <Nimg src="./images/career/section1.jpg" />
      </figure>
      <div class="section2__titleBox">
        <div class="section2__titleBox__inner">
          <div class="section2__titleBox__title">
            創造能讓彼此<br />
            不斷成長的工作環境
          </div>
          <div class="section2__titleBox__text">
            恆隆行專注於人才培育及專業能力的養成，讓每一個人依照個人特質與專長，在管理或專業領域中獲取良好的發展。同時，也重視各階層主管的管理能力，提供多元學習資源與管道，實現自我未來的無限可能。
          </div>
        </div>
      </div>
    </div>
    <div class="section2__box">
      <figure class="section2__pic">
        <Nimg src="./images/career/section2.jpg" />
      </figure>
      <div class="section2__titleBox">
        <div class="section2__titleBox__inner">
          <div class="section2__titleBox__title">結合多元學習資源<br />強化人才實力的養成</div>
          <div class="section2__titleBox__text">
            規劃個人專屬的發展目標，鼓勵運用多元學習管道與知識學習平台，讓每個人都能持續追求個人成長，且落實知識共享及傳承。
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.section2 {
  &__box {
    position: relative;
    overflow: hidden;

    &:nth-child(odd) {
      .section2__titleBox__inner {
        grid-column: 3 / span 3;

        @include max-media(990) {
          grid-column: 1 / span 4;
        }
      }
    }

    &:nth-child(even) {
      opacity: 0.2;

      .section2__titleBox__inner {
        grid-column: 9 / span 3;

        @include max-media(990) {
          grid-column: 1 / span 4;
        }
      }
    }
  }

  &__pic {
    height: 100vh;

    &::before {
      content: " ";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.2);
    }

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__titleBox {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    color: $color-white-1;
    padding-left: toRem(30);
    padding-right: toRem(30);
    @include grid;

    @include max-media(990) {
      @include grid(4, 24);
    }

    // &__inner {
    //   @include max-media(990) {
    //     transform: translateX(toRem(24));
    //   }
    // }

    &__title {
      margin-bottom: toRem(24);
      font-size: toRem(32);
      font-weight: 500;
      line-height: 1.3;
    }

    &__text {
      font-size: toRem(16);
      line-height: 1.45;
    }
  }
}
</style>
